export default __webpack_public_path__ + "9d932ec701c03e60156549558bdcc0c1.svg";